import { helpers } from "vuelidate/lib/validators";

export const maxLines = (max) =>
  helpers.withParams({ type: "maxLines", max }, (value) => {
    return value && value.trim().split("\n").length <= max;
  });
